export default __webpack_public_path__ + "static/media/p12.a9e8adc0.jpg";